import { FC } from 'react';

import type { ProductSummaryCellMetadata, ProductSummaryScheduleDatesRow } from './ScheduleDate.model';
import { fieldForType } from './ScheduleDatesRows.helper';

interface ProductSummaryScheduleDatesRowsProps {
  scheduleDatesRows: ProductSummaryScheduleDatesRow[];
  metadata: ProductSummaryCellMetadata[];
}

export const ProductSummaryScheduleDatesRows: FC<ProductSummaryScheduleDatesRowsProps> = ({
  scheduleDatesRows,
  metadata,
}) => {
  return (
    <tbody>
      {scheduleDatesRows.map((scheduleDatesRow: ProductSummaryScheduleDatesRow, rowIndex) => {
        return (
          <tr key={`scheduleDatesRow-${rowIndex}`}>
            <td className="text-regular fw-light m-0">{rowIndex + 1}</td>
            {metadata.map((cellMetadata, cellIndex) => {
              if (cellIndex > 0) {
                const NodeComponent = fieldForType(cellMetadata.type);
                return (
                  <td key={`scheduleDatesCell-${rowIndex}-${cellIndex}`} className="text-regular fw-light m-0">
                    <NodeComponent scheduleDatesRow={scheduleDatesRow} cellMetadata={cellMetadata} />
                  </td>
                );
              }
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

ProductSummaryScheduleDatesRows.displayName = 'ProductSummaryScheduleDatesRows';
